import { takeLatest, all, select, put } from 'redux-saga/effects';
import queryString from 'query-string';
import { showPageAction } from 'src/routes/HotelReviewsPage/store/actions/view';
import { HOTEL_MOBILE_PAGES } from 'src/routes/HotelReviewsPage/constants';
import {
  UPDATE_REQUEST_ID,
  SET_SEARCHER_CAROUSEL_DATE,
} from '../constants/searcher';
import {
  getSearcherCarouselDate,
  getSearcherIsCarouselDateFromRange,
} from '../selectors/searcher';
import {
  getSearchOfferNights,
  getSearchOfferPrice,
} from '../selectors/searchOffer';
import {
  getSearchParamsAdults,
  getSearchParamsFromCity,
  getSearchParamsKidsAgesText,
  getSearchParamsNights,
  getSearchParamsStartDate,
  getSearchParamsFromCountry,
} from '../../../../store/enqueue/selectors';

import { getSearchParamsForUrl } from '../selectors/searchParams';

import {
  convertClientDateToServerDate,
  convertServerDateToClientDate,
  checkDateFormat,
} from '../../../../utils/dateUtils';
import { COMMIT_SEARCH_PARAMS } from '../constants/searchParams';
import { INIT_APP } from '../../../../store/view/constants';
import ViewedHotels from '../../../../helpers/ViewedHotels';
import { isSSR } from '../../../../helpers/ssr';
import { getSearchType } from '../selectors/view';
import { getHotelId } from '../hotel';

function* getOfferParams() {
  const offerPrice = yield select(getSearchOfferPrice);
  const offerNights = yield select(getSearchOfferNights);
  const offerDate = yield select(getSearcherCarouselDate);
  return {
    offer_price: offerPrice,
    offer_nights: offerNights,
    offer_date: convertClientDateToServerDate(offerDate),
  };
}

/**
 * Обновляет query params в url
 * @param {object} queryParams
 */
function updateUrlQueryParams(queryParams) {
  const {
    location: { search, href },
    history,
    document,
  } = window;
  const newSearchString = `${href.replace(search, '')}?${queryString.stringify(
    queryParams,
  )}`;
  history.replaceState({}, document.title, newSearchString);
}

function* updateRequestId() {
  const {
    location: { search },
  } = window;
  const current = queryString.parse(search);
  const searchParams = yield select(getSearchParamsForUrl);
  const { start_date } = searchParams;
  searchParams.start_date = checkDateFormat(start_date)
    ? start_date
    : convertServerDateToClientDate(start_date);
  const offerParams = yield getOfferParams();

  updateUrlQueryParams({ ...current, ...searchParams, ...offerParams });
}

function* handleCommitSearchParams() {
  yield takeLatest(UPDATE_REQUEST_ID, updateRequestId);
}

function* handleUpdateOfferParams() {
  const isCorrectOfferDate = yield select(getSearcherIsCarouselDateFromRange);

  if (!isCorrectOfferDate) {
    return;
  }

  const {
    location: { search },
  } = window;
  const current = queryString.parse(search);
  const offerParams = yield getOfferParams();

  updateUrlQueryParams({ ...current, ...offerParams });
}

function* setDefaultParams() {
  const adults = yield select(getSearchParamsAdults);
  const fromCity = yield select(getSearchParamsFromCity);
  const fromCountry = yield select(getSearchParamsFromCountry);
  const kids = yield select(getSearchParamsKidsAgesText);
  const nights = yield select(getSearchParamsNights);
  const startDate = yield select(getSearchParamsStartDate);
  const searchType = yield select(getSearchType);

  const from = `${fromCity}-${fromCountry}`;

  return {
    adults,
    from,
    kids,
    nights,
    start_date: startDate,
    search_type: searchType,
  };
}

function* getDefaultParams() {
  if (isSSR || window.location.search) {
    return;
  }
  const defaultParams = yield setDefaultParams();
  const current = queryString.parse(window.location.search);
  updateUrlQueryParams({ ...current, ...defaultParams });
}

// помечает просмотр отеля
function* handleInitApp() {
  const hotelId = yield select(getHotelId);
  yield getDefaultParams();
  ViewedHotels.setViewed(hotelId);
  const searchParams = new URLSearchParams(window.location.search);
  const showPrices = searchParams.get('show_prices');
  if (showPrices) {
    yield put(showPageAction(HOTEL_MOBILE_PAGES.SEARCHER));
  }
}

export default function* sagas() {
  yield all([
    takeLatest(INIT_APP, handleInitApp),
    takeLatest(COMMIT_SEARCH_PARAMS, handleCommitSearchParams),
    takeLatest(SET_SEARCHER_CAROUSEL_DATE, handleUpdateOfferParams),
  ]);
}
